import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { featureMap } from "../../Drawer/userDrawerItems";
import DrawerItems from "../../Drawer/DrawerItem";

interface PermissionGuardProps {
  children: React.ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({ children }) => {
  const { hasFeature, isValidUser } = useAuth();
  const location = useLocation();

  if (!isValidUser()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const currentPath = location.pathname;
  
  // Find the drawer item that matches the current path
  const currentItem = DrawerItems.find(item => item.path === currentPath);
  
  if (currentItem) {
    const requiredFeatures = featureMap[currentItem.key];
    
    // If not in map, assume it's protected and forbidden
    if (requiredFeatures === undefined) {
      return <Navigate to="/forbidden" replace />;
    }

    // If mapped to an empty array, it's public (e.g., /account)
    if (requiredFeatures.length === 0) {
      return <>{children}</>;
    }

    // Check if user has ANY of the required features
    const hasAccess = requiredFeatures.some((feature) => hasFeature(feature));
    
    if (!hasAccess) {
      return <Navigate to="/forbidden" replace />;
    }
  }

  return <>{children}</>;
};

export default PermissionGuard;
